/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddWishlistSupplierMutationVariables = Exact<{
  companyId: string;
  role_assignment_id: string;
  supplier_id: string;
}>;


export type AddWishlistSupplierMutation = { addWishlistSupplier: { id: string } | null };


export const AddWishlistSupplierDocument = /*#__PURE__*/ gql`
    mutation AddWishlistSupplier($companyId: uuid!, $role_assignment_id: uuid!, $supplier_id: uuid!) {
  addWishlistSupplier(
    companyId: $companyId
    role_assignment_id: $role_assignment_id
    supplier_id: $supplier_id
  ) {
    id
  }
}
    `;
export type AddWishlistSupplierMutationFn = Apollo.MutationFunction<AddWishlistSupplierMutation, AddWishlistSupplierMutationVariables>;

/**
 * __useAddWishlistSupplierMutation__
 *
 * To run a mutation, you first call `useAddWishlistSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWishlistSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWishlistSupplierMutation, { data, loading, error }] = useAddWishlistSupplierMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      role_assignment_id: // value for 'role_assignment_id'
 *      supplier_id: // value for 'supplier_id'
 *   },
 * });
 */
export function useAddWishlistSupplierMutation(baseOptions?: Apollo.MutationHookOptions<AddWishlistSupplierMutation, AddWishlistSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWishlistSupplierMutation, AddWishlistSupplierMutationVariables>(AddWishlistSupplierDocument, options);
      }
export type AddWishlistSupplierMutationHookResult = ReturnType<typeof useAddWishlistSupplierMutation>;
export type AddWishlistSupplierMutationResult = Apollo.MutationResult<AddWishlistSupplierMutation>;
export type AddWishlistSupplierMutationOptions = Apollo.BaseMutationOptions<AddWishlistSupplierMutation, AddWishlistSupplierMutationVariables>;